"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** The list of personality types. */
exports.default = Object.freeze([
    '000',
    '001',
    '012',
    '024',
    '025',
    '100',
    '108',
    '125',
    '555',
    '789',
    '888',
    '919',
]);
//# sourceMappingURL=genius.js.map